// src/services/LeadChannelsService.js
import Axhelper from '@/lib/Axhelper'

class LeadChannelsService {
	constructor() {
		this.baseUrl = window.RUNTIME_CONFIG.API_URL
		this.endpoints = {
			all: `/api/leadchannels/all`,
			details: `/api/leadchannels/details`,
			add: `/api/leadchannels/`,
			update: `/api/leadchannels/`,
			remove: `/api/leadchannels/`
		}
	}

	/**
	 * Fetch all lead channels (GET /leadchannels/all)
	 * @returns {Promise<{data: Array, error: string|null}>}
	 */
	async getAllLeadChannels() {
		try {
			const res = await Axhelper.sendGetAsync(this.endpoints.all)
			if (res?.error) {
				return { data: [], error: res.error }
			}
			return { data: Array.isArray(res?.data) ? res.data : [], error: null }
		} catch (e) {
			console.error('LeadChannelsService.getAllLeadChannels error:', e)
			return { data: [], error: e?.message || 'Failed to fetch lead channels' }
		}
	}

	/**
	 * Fetch single lead channel by id (GET /leadchannels/details/:id)
	 * Kept for convenience; safe to remove if unused.
	 */
	async getLeadChannelById(leadChannelId) {
		try {
			if (!leadChannelId) return { data: null, error: 'Invalid lead channel ID' }
			const url = `${this.endpoints.details}/${encodeURIComponent(leadChannelId)}`
			const res = await Axhelper.sendGetAsync(url)
			if (res?.error) return { data: null, error: res.error }
			return { data: res?.data ?? null, error: null }
		} catch (e) {
			console.error('LeadChannelsService.getLeadChannelById error:', e)
			return { data: null, error: e?.message || 'Failed to fetch lead channel' }
		}
	}

	async addLeadChannel(leadChannelData) {
		try {
			const res = await Axhelper.sendPostAsync(this.endpoints.add, leadChannelData)
			if (res?.error) {
				return { data: null, error: res.error }
			}
			return { data: res?.data ?? null, error: null }
		} catch (e) {
			console.error('LeadChannelsService.addLeadChannel error:', e)
			return { data: null, error: e?.message || 'Failed to add lead channel' }
		}
	}

	async updateLeadChannel(leadChannelId, leadChannelData) {
		try {
			if (!leadChannelId) {
				return { data: null, error: 'Invalid lead channel ID' }
			}
			const url = `${this.endpoints.update}${encodeURIComponent(leadChannelId)}`
			const res = await Axhelper.sendPutAsync(url, leadChannelData)
			if (res?.error) {
				return { data: null, error: res.error }
			}
			return { data: res?.data ?? null, error: null }
		} catch (e) {
			console.error('LeadChannelsService.updateLeadChannel error:', e)
			return { data: null, error: e?.message || 'Failed to update lead channel' }
		}
	}

	async deleteLeadChannel(leadChannelId) {
		try {
			if (!leadChannelId) {
				return { data: null, error: 'Invalid lead channel ID' }
			}
			const url = `${this.endpoints.remove}${encodeURIComponent(leadChannelId)}`
			const res = await Axhelper.sendDeleteAsync(url)
			if (res?.error) {
				return { data: null, error: res.error }
			}
			return { data: res?.data ?? null, error: null }
		} catch (e) {
			console.error('LeadChannelsService.deleteLeadChannel error:', e)
			return { data: null, error: e?.message || 'Failed to delete lead channel' }
		}
	}
	
}

export default new LeadChannelsService()
